<product-card class="d-block px-3 pt-3"
              (click)="onProductTypeClick($event)"
              [ngClass]="{
                'pb-3': uiContext.isXs() || itemCount,
                'pb-sm-1': !uiContext.isXs() && !itemCount,
                'cart-line-in-cart': !!itemCount
              }">
  @if (showImage && !!productType.image) {
    <product-image class="me-3"
                   data-modal-ignore
                   [imagePreviewTrigger]="productType.image.original">
      <img [src]="productType.image.small" [alt]="productType.name">
    </product-image>
  }

  <product-header class="d-flex justify-content-between align-items-start">
    <div class="fw-bold w-60 product-card__product-name"
         [class.product-card__product-name-xs]="shouldUseCompactLayout">
      {{ productType.name }}
    </div>

    @if (!itemCount) {
      <div class="d-flex align-items-center"
           data-modal-ignore>
        @if (sizes?.length > 1) {
          <span class="font-sm me-1" [translate]="'common.from'">from</span>
        }&nbsp;
        <product-price [price]="minSizePrice"
                       [discount]="productType.discount?.value"
                       [currency]="productType?.bakery?.country?.currencySymbol"
                       [smallSize]="shouldUseCompactLayout">
        </product-price>

        <button class="ms-2 pointer btn-primary-themed add-to-cart-btn"
                (click)="onAddToCartClick()">
          <i class="icon-plus add-to-cart-icon"></i>
        </button>
      </div>
    }
  </product-header>

  @if (!!itemCount) {
    <product-counter data-modal-ignore>
      @if (!isMultiBuild) {
        <ui-single-pieces-counter
          counter
          [step]="1"
          [maxCount]="maxCount"
          [count]="itemCount"
          [size]="'xs'"
          [btnHighlighting]="true"
          [btnStyle]="'btn-pink'"
          [isPlusDisabled]="isCounterPlusDisabled"
          [isAllowEnterCounter]="false"
          (onCountUpdated)="countUpdate($event)"
        ></ui-single-pieces-counter>
      }

      @if (!isMultiBuild && !!cartLine) {
        <div price class="fw-bold text-center mt-1">
          {{ cartLine?.fullPrice | currencyFormat: productType?.bakery?.country?.currencySymbol }}
        </div>
      }

      <product-cart-actions
        actions
        [buildsCount]="buildsCount"
        [showEdit]="shouldShowModalOnAdd"
        [showAddNew]="shouldShowModalOnAdd"
        (edit)="onShowModal()"
        (addNew)="onAddNew()"
        (showCart)="onShowCart()"
      ></product-cart-actions>
    </product-counter>
  }

  <product-description [class.small-description]="showImage && !!productType.image">
    @if (!uiContext.isXs()) {
      <div class="font-sm text-muted"
           [innerHTML]="productType?.description">
      </div>
    } @else {
      <product-description-slice
        class="font-sm text-muted"
        [lines]="2"
        [text]="productType?.description"
      ></product-description-slice>
    }
  </product-description>

  <product-allergens class="d-block mt-1"
                     [allergens]="productType.allergens">
  </product-allergens>

  @if (chosenSize && !isMultiBuild) {
    <chosen-options class="d-block mt-2">
      <div unitSize>
        {{chosenSize.value}}&nbsp;{{chosenSize.measurement}}&nbsp;{{chosenSize.definition ? '| ' + chosenSize.definition : ''}}
      </div>
      <div variant class="text-overflow mt-1">
        {{ cartLine.product?.variant?.name }}
      </div>
      @if (chosenOptions?.length) {
        <div addOns class="mt-2">
          <span class="fw-bold"
                [translate]="'productsList.productCard.addedOptions'">
          </span>
          <span>: {{ chosenOptions }}</span>
        </div>
      }
    </chosen-options>
  }

  <product-availability-info
    [availability]="productType?.availability"
    [cssClass]="'font-md mt-1'">
  </product-availability-info>
</product-card>
